import { createContext, useContext, useMemo } from 'react'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import { useTilesStore } from '../../stores/RootStoreProvider'

const BulkCustomizationContext = createContext()
BulkCustomizationContext.displayName = 'BulkCustomizationContext'

export function useBulkCustomization() {
  const context = useContext(BulkCustomizationContext)

  if (context === undefined) {
    throw new Error('useBulkCustomization must be used within a TilesProvider')
  }

  return context
}

const BulkCustomizationProvider = observer(function BulkCustomizationProvider({
  children,
}) {
  const { bulkCustomizationStore: store } = useTilesStore()

  const baseStyling = toJS(store.baseStyling)
  const bulkCustomization = toJS(store.bulkCustomization)
  const lastFramedColor = store.lastFramedColor
  const currentSelection = store.currentSelection

  const value = useMemo(
    () => ({
      baseStyling,
      lastFramedColor,
      bulkCustomization,
      currentSelection,
      setCurrentSelection: (sel) => store.setCurrentSelection(sel),
      resetToFallbackStyle: () => store.resetToFallbackStyle(),
      updateBulk: {
        materialType: (bulkMaterial) => store.setMaterialType(bulkMaterial),
        tileSize: (size) => store.setTileSize(size),
        matting: (matting) => store.setMatting(matting),
        filter: (filter) => store.setFilter(filter),
        frameColor: (color) => store.setFrameColor(color),
        mattingColor: (color) => store.setMattingColor(color),
      },
    }),
    [baseStyling, lastFramedColor, bulkCustomization, currentSelection, store]
  )

  return (
    <BulkCustomizationContext.Provider value={value}>
      {children}
    </BulkCustomizationContext.Provider>
  )
})

export default BulkCustomizationProvider
